module.exports = __webpack_public_path__ + "img/6c574cb.png";